/*
 * File: form-elements.data.ts
 * File Created: 2024-01-19 10:44:28
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-09-16 06:20:31
 * Modified By: Val Liu
 * -----
 */

// import { Profile_PropertyEquipmentPartsInventory } from "@/views/AdminPages/PropertyEquipmentPartsInventory/quick";
// import { Profile_PropertyGroup } from "@/views/AdminPages/PropertyGroup/quick";
// import { Profile_PropertyRentalUnit } from "@/views/AdminPages/PropertyRentalUnit/quick";

export const formData = [
    createDefaultData("Month", "iv-form-month", [
        undefined,
        undefined,
        undefined,
        undefined,
        new Date(2024, 3, 1),
        undefined,
    ]),

    createDefaultData("Cron", "iv-form-cron", [
        undefined,
        undefined,
        undefined,
        undefined,
        "0 0 0 1 * * *",
        undefined,
    ]),

    // createDefaultData(
    //     "Tree Select",
    //     "iv-form-tree-select",
    //     [undefined, undefined, undefined, undefined, { id: "123" }, undefined],
    //     { quicks: [Profile_PropertyGroup, Profile_PropertyEquipmentPartsInventory] },
    // ),

    createDefaultData(
        "File (multiple)",
        "iv-form-file",
        [undefined, undefined, undefined, undefined, [{ id: "123" }], undefined],
        { multiple: true },
    ),
    createDefaultData("File", "iv-form-file", [
        undefined,
        undefined,
        undefined,
        undefined,
        { id: "123" },
        undefined,
    ]),
    createDefaultData("File Classic", "iv-form-file-classic", [
        undefined,
        undefined,
        undefined,
        undefined,
        new File([], "123.jpg"),
        undefined,
    ]),
    createDefaultData("String", "iv-form-string", [
        undefined,
        undefined,
        "String",
        "String",
        "String",
        "String",
    ]),
    createDefaultData("Password", "iv-form-password", [
        undefined,
        undefined,
        "Az",
        "Az123567!",
        "Az123567!",
        "Az123567!",
    ]),
    createDefaultData("Number", "iv-form-number", [undefined, undefined, 30, 30, 30, 30]),
    createDefaultData(
        "Select",
        "iv-form-select",
        [undefined, undefined, "Admin", "Admin", "Admin", "Admin"],
        {
            options: {
                一般使用者: "User",
                系統管理員: "Admin",
            },
        },
    ),
    createDefaultData("Switch", "iv-form-switch", [
        undefined,
        undefined,
        true,
        true,
        true,
        true,
    ]),

    createDefaultData(
        "Check",
        "iv-form-check",
        [undefined, undefined, "yes", "yes", "yes", "yes"],
        {
            multiple: false,
            options: {
                否: "no",
                是: "yes",
            },
        },
    ),

    createDefaultData(
        "Check (multiple)",
        "iv-form-check",
        [undefined, undefined, 1, 1, 1, 1],
        {
            multiple: true,
            options: {
                否: 0,
                是: 1,
            },
        },
    ),

    createDefaultData("Datetime", "iv-form-datetime", [
        undefined,
        undefined,
        new Date(),
        new Date(),
        new Date(),
        new Date(),
    ]),

    createDefaultData("Date", "iv-form-date", [
        undefined,
        undefined,
        new Date(),
        new Date(),
        new Date(),
        new Date(),
    ]),

    createDefaultData("Time", "iv-form-time", [
        undefined,
        undefined,
        new Date(),
        new Date(),
        new Date(),
        new Date(),
    ]),

    createDefaultData("Textarea", "iv-form-textarea", [
        undefined,
        undefined,
        "這是一段測試文字",
        "這是一段測試文字",
        "這是一段測試文字",
        "這是一段測試文字",
    ]),
];

function createDefaultData(name: string, is: string, values: any[], args?: any) {
    const type = is;
    return {
        type: is,
        normal: {
            is: "iv-form",
            interface: `
            interface Any {
                /// @uiLabel - ${name}
                /// @uiType - ${is}
                /// @uiAttrs - ${JSON.stringify(args ?? {})}
                field?: any;
            }
            `,
            value: { field: values[0] },
        },
        required: {
            is: "iv-form",
            interface: `
            interface Any {
                /// @uiLabel - ${name}
                /// @uiType - ${is}
                /// @uiAttrs - ${JSON.stringify(args ?? {})}
                field: any;
            }
            `,
            value: { field: values[1] },
        },
        defaultInvalid: {
            is: "iv-form",
            interface: `
            interface Any {
                /// @uiLabel - ${name}
                /// @uiType - ${is}
                /// @uiAttrs - ${JSON.stringify(args ?? {})}
                field?: any;
            }
            `,
            value: { field: values[2] },
        },
        stateTrue: {
            is: "iv-form",
            interface: `
            interface Any {
                /// @uiLabel - ${name}
                /// @uiType - ${is}
                /// @uiValidatorAfter - { state: true, message: "Success" }
                /// @uiAttrs - ${JSON.stringify(args ?? {})}
                field?: any;
            }
            `,
            value: { field: values[3] },
        },
        stateFalse: {
            is: "iv-form",
            interface: `
            interface Any {
                /// @uiLabel - ${name}
                /// @uiType - ${is}
                /// @uiValidator - { state: false, message: "Fail" }
                /// @uiAttrs - ${JSON.stringify(args ?? {})}
                field?: any;
            }
            `,
            value: { field: values[4] },
        },
        disabled: {
            is: "iv-form",
            interface: `
            interface Any {
                /// @uiLabel - ${name}
                /// @uiType - ${is}
                /// @uiDisabled
                /// @uiAttrs - ${JSON.stringify(args ?? {})}
                field?: any;
            }
            `,
            value: { field: values[5] },
        },
    };
}
